var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeoinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 61,
    viewBox: "0 0 124 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_128)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6857 57.4181C37.6857 58.0271 37.5922 58.5608 37.4233 58.9829C37.2513 59.4051 37.028 59.7639 36.7535 60.0322C36.4759 60.3126 36.1621 60.5026 35.8212 60.6262C35.4652 60.7498 35.1243 60.8132 34.7834 60.8132H32.59C31.9081 60.8132 31.3017 60.7348 30.7767 60.5629C30.2638 60.391 29.7781 60.0925 29.3044 59.6553C28.8458 59.2181 28.3722 58.6241 27.9106 57.8703C27.452 57.1196 26.9511 56.1336 26.4262 54.9456L11.2083 21.1998C10.4057 19.4631 9.60623 17.6328 8.8037 15.7242C7.9891 13.8156 7.24088 11.9523 6.54394 10.1552H6.4655C6.51679 12.3442 6.55903 14.5996 6.58316 16.8971C6.61032 19.1826 6.62238 21.4651 6.62238 23.7175V59.5287C6.62238 59.7488 6.57109 59.9508 6.4655 60.1558C6.34783 60.3428 6.1638 60.4996 5.91338 60.6081C5.6509 60.7167 5.32204 60.8101 4.90268 60.8885C4.48331 60.9669 3.94326 60.9971 3.30063 60.9971C2.64292 60.9971 2.10589 60.9669 1.6835 60.8885C1.26414 60.8101 0.93528 60.7167 0.696934 60.6081C0.446521 60.4996 0.277567 60.3428 0.156886 60.1558C0.0512895 59.9538 0 59.7488 0 59.5317V4.7882C0 3.56706 0.289635 2.69266 0.880973 2.17405C1.45723 1.65845 2.0908 1.39312 2.78472 1.39312H6.04311C6.80642 1.39312 7.44905 1.47151 7.96195 1.6283C8.48691 1.77001 8.94852 2.03535 9.35581 2.37908C9.76311 2.72281 10.1704 3.22333 10.5506 3.85048C10.9307 4.47764 11.338 5.25857 11.7604 6.21438L23.4544 32.2474C24.1785 33.8424 24.8724 35.3922 25.5422 36.9089C26.212 38.4255 26.8697 39.912 27.4882 41.3834C28.1067 42.8397 28.7221 44.293 29.3286 45.7162C29.9471 47.1243 30.5384 48.5625 31.1418 50.0038H31.181C31.1297 47.5796 31.0875 45.074 31.0754 42.4628C31.0634 39.8487 31.0634 37.331 31.0634 34.9219V2.76804C31.0634 2.54793 31.1146 2.34591 31.2202 2.17405C31.3379 1.98711 31.5219 1.83032 31.7724 1.6886C32.0348 1.54689 32.3758 1.45342 32.7831 1.3901C33.2024 1.32678 33.7546 1.29663 34.4394 1.29663C35.0308 1.29663 35.5436 1.32678 35.9781 1.3901C36.4126 1.45342 36.7535 1.54689 36.9888 1.6886C37.2392 1.83032 37.4082 1.98711 37.5289 2.17405C37.6345 2.34591 37.6857 2.55094 37.6857 2.76804V57.4181Z",
    fill: "url(#paint0_linear_52_128)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 38,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6857 57.4181C37.6857 58.0271 37.5922 58.5608 37.4233 58.9829C37.2513 59.4051 37.028 59.7639 36.7535 60.0322C36.4759 60.3126 36.1621 60.5026 35.8212 60.6262C35.4652 60.7498 35.1243 60.8132 34.7834 60.8132H32.59C31.9081 60.8132 31.3017 60.7348 30.7767 60.5629C30.2638 60.391 29.7781 60.0925 29.3044 59.6553C28.8458 59.2181 28.3722 58.6241 27.9106 57.8703C27.452 57.1196 26.9511 56.1336 26.4262 54.9456L11.2083 21.1998C10.4057 19.4631 9.60623 17.6328 8.8037 15.7242C7.9891 13.8156 7.24088 11.9523 6.54394 10.1552H6.4655C6.51679 12.3442 6.55903 14.5996 6.58316 16.8971C6.61032 19.1826 6.62238 21.4651 6.62238 23.7175V59.5287C6.62238 59.7488 6.57109 59.9508 6.4655 60.1558C6.34783 60.3428 6.1638 60.4996 5.91338 60.6081C5.6509 60.7167 5.32204 60.8101 4.90268 60.8885C4.48331 60.9669 3.94326 60.9971 3.30063 60.9971C2.64292 60.9971 2.10589 60.9669 1.6835 60.8885C1.26414 60.8101 0.93528 60.7167 0.696934 60.6081C0.446521 60.4996 0.277567 60.3428 0.156886 60.1558C0.0512895 59.9538 0 59.7488 0 59.5317V4.7882C0 3.56706 0.289635 2.69266 0.880973 2.17405C1.45723 1.65845 2.0908 1.39312 2.78472 1.39312H6.04311C6.80642 1.39312 7.44905 1.47151 7.96195 1.6283C8.48691 1.77001 8.94852 2.03535 9.35581 2.37908C9.76311 2.72281 10.1704 3.22333 10.5506 3.85048C10.9307 4.47764 11.338 5.25857 11.7604 6.21438L23.4544 32.2474C24.1785 33.8424 24.8724 35.3922 25.5422 36.9089C26.212 38.4255 26.8697 39.912 27.4882 41.3834C28.1067 42.8397 28.7221 44.293 29.3286 45.7162C29.9471 47.1243 30.5384 48.5625 31.1418 50.0038H31.181C31.1297 47.5796 31.0875 45.074 31.0754 42.4628C31.0634 39.8487 31.0634 37.331 31.0634 34.9219V2.76804C31.0634 2.54793 31.1146 2.34591 31.2202 2.17405C31.3379 1.98711 31.5219 1.83032 31.7724 1.6886C32.0348 1.54689 32.3758 1.45342 32.7831 1.3901C33.2024 1.32678 33.7546 1.29663 34.4394 1.29663C35.0308 1.29663 35.5436 1.32678 35.9781 1.3901C36.4126 1.45342 36.7535 1.54689 36.9888 1.6886C37.2392 1.83032 37.4082 1.98711 37.5289 2.17405C37.6345 2.34591 37.6857 2.55094 37.6857 2.76804V57.4181Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6857 1.29663H0V61.0001H37.6857V1.29663Z",
    fill: "url(#paint1_linear_52_128)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 0,
    width: 40,
    height: 61
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 30.2966C117.734 27.0402 117.51 23.9979 117.064 21.1968C116.617 18.3987 115.878 15.9624 114.834 13.894C113.79 11.8407 112.405 10.2276 110.668 9.06975C108.918 7.91493 106.77 7.33602 104.211 7.33602C101.641 7.33602 99.4925 7.96016 97.7547 9.20844C96.0169 10.4567 94.5959 12.1151 93.5188 14.1835C92.4267 16.267 91.6513 18.6882 91.1836 21.4712C90.713 24.2391 90.4807 27.1457 90.4807 30.2031C90.4807 33.5952 90.7039 36.7008 91.1384 39.5441C91.5728 42.4055 92.2999 44.8538 93.3318 46.9222C94.3515 48.9756 95.7394 50.5736 97.4621 51.7134C99.1878 52.8531 101.36 53.432 103.964 53.432C106.558 53.432 108.731 52.8079 110.49 51.5596C112.252 50.3113 113.67 48.6379 114.75 46.5092C115.818 44.3955 116.593 41.9291 117.049 39.1461C117.51 36.3691 117.734 33.4173 117.734 30.2966ZM124 29.7659C124 34.4364 123.577 38.6366 122.733 42.3784C121.876 46.1202 120.609 49.3012 118.928 51.9335C117.239 54.5506 115.127 56.5738 112.577 57.9879C110.031 59.4021 107.062 60.1016 103.668 60.1016C100.322 60.1016 97.4349 59.4624 94.9941 58.1689C92.5413 56.8753 90.535 54.9878 88.939 52.5244C87.343 50.061 86.1573 47.0006 85.3819 43.3493C84.5944 39.6979 84.2083 35.4978 84.2083 30.7519C84.2083 26.202 84.6306 22.0652 85.4754 18.3505C86.3322 14.6388 87.5994 11.4879 89.301 8.88582C90.9905 6.2988 93.1145 4.29069 95.6639 2.87658C98.1982 1.46246 101.17 0.762939 104.573 0.762939C107.847 0.762939 110.701 1.40216 113.13 2.68059C115.558 3.95902 117.589 5.81336 119.197 8.26469C120.817 10.713 122.027 13.7433 122.811 17.3645C123.602 20.9706 124 25.1105 124 29.7659Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.003 0.766113H84.2114V60.1048H124.003V0.766113Z",
    fill: "url(#paint2_linear_52_128)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 40,
    width: 40,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3681 50.5524L78.8199 40.738C79.538 40.545 80.2802 41.0154 80.3073 41.7571L80.5336 47.9473C80.5607 48.689 79.5802 48.7191 78.8652 48.9181L42.6216 58.9888C41.9065 59.1878 41.5807 58.5788 41.5626 57.837L41.4148 52.2047C41.3937 51.463 41.6501 50.7453 42.3681 50.5524Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5607 40.5419H41.3936V59.1847H80.5607V40.5419Z",
    fill: "url(#paint3_linear_52_128)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 20,
    width: 40,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3681 30.2784L78.8199 20.464C79.538 20.2711 80.2802 20.7414 80.3073 21.4832L80.5336 27.6733C80.5607 28.4151 79.5802 28.4452 78.8652 28.6442L42.6216 38.7149C41.9065 38.9139 41.5807 38.3048 41.5626 37.5631L41.4148 31.9308C41.3937 31.189 41.6501 30.4714 42.3681 30.2784Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5607 20.271H41.3936V38.9138H80.5607V20.271Z",
    fill: "url(#paint4_linear_52_128)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 0,
    width: 40,
    height: 19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3681 10.0074L78.8199 0.193052C79.538 8.12709e-05 80.2802 0.470449 80.3073 1.21218L80.5336 7.40234C80.5607 8.14407 79.5802 8.17422 78.8652 8.37021L42.6216 18.4409C41.9065 18.6399 41.5807 18.0308 41.5626 17.2891L41.4148 11.6567C41.3937 10.918 41.6501 10.2004 42.3681 10.0074Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5607 0H41.3936V18.6428H80.5607V0Z",
    fill: "url(#paint5_linear_52_128)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 25,
    width: 4,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 37.5299V27.1486C97.8 26.6089 97.9117 26.2079 98.138 25.9365C98.3612 25.6651 98.6539 25.5325 99.0129 25.5325C99.378 25.5325 99.6766 25.6651 99.9029 25.9305C100.129 26.1988 100.247 26.6029 100.247 27.1486V37.5299C100.247 38.0756 100.132 38.4826 99.9029 38.751C99.6766 39.0224 99.378 39.155 99.0129 39.155C98.6629 39.155 98.3733 39.0193 98.144 38.748C97.9147 38.4766 97.8 38.0696 97.8 37.5299Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.244 25.5325H97.8V39.158H100.244V25.5325Z",
    fill: "url(#paint6_linear_52_128)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_52_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 25,
    width: 10,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.097 27.4291V27.8331C106.547 27.0582 107.041 26.4944 107.572 26.1325C108.106 25.7707 108.719 25.5928 109.413 25.5928C110.089 25.5928 110.689 25.7828 111.223 26.1657C111.754 26.5456 112.149 27.0853 112.412 27.7849C112.581 28.1919 112.689 28.6291 112.741 29.1055C112.789 29.5759 112.813 30.1759 112.813 30.9086V37.1048C112.813 37.7711 112.695 38.2746 112.46 38.6154C112.228 38.9561 111.92 39.1279 111.546 39.1279C111.166 39.1279 110.855 38.9531 110.617 38.6033C110.381 38.2535 110.261 37.753 110.261 37.1048V31.5538C110.261 30.4593 110.143 29.6181 109.908 29.0362C109.675 28.4572 109.208 28.1678 108.508 28.1678C108.055 28.1678 107.639 28.3427 107.262 28.6954C106.887 29.0482 106.613 29.5367 106.441 30.1548C106.317 30.6493 106.251 31.5749 106.251 32.9348V37.1048C106.251 37.7802 106.13 38.2837 105.889 38.6184C105.651 38.9561 105.34 39.1249 104.963 39.1249C104.595 39.1249 104.293 38.95 104.055 38.6003C103.819 38.2505 103.698 37.75 103.698 37.1017V27.4773C103.698 26.8441 103.804 26.3707 104.015 26.0572C104.229 25.7436 104.516 25.5868 104.884 25.5868C105.107 25.5868 105.313 25.6561 105.491 25.7948C105.672 25.9335 105.816 26.1416 105.925 26.416C106.043 26.6934 106.097 27.0341 106.097 27.4291Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_52_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.813 25.59H103.705V39.1221H112.813V25.59Z",
    fill: "url(#paint7_linear_52_128)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1185 23.7324C98.7625 23.7324 98.4578 23.6178 98.2014 23.3887C97.9419 23.1595 97.8152 22.8369 97.8152 22.4268C97.8152 22.0741 97.9389 21.7756 98.1863 21.5223C98.4337 21.269 98.7384 21.1454 99.1004 21.1454C99.4625 21.1454 99.7702 21.269 100.024 21.5193C100.28 21.7695 100.404 22.071 100.404 22.4299C100.404 22.8339 100.277 23.1535 100.024 23.3857C99.7642 23.6148 99.4655 23.7324 99.1185 23.7324Z",
    fill: "#00E9E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_128",
    x1: 0,
    y1: 31.1494,
    x2: 37.687,
    y2: 31.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_128",
    x1: 19.3823,
    y1: 3.66915,
    x2: 18.3306,
    y2: 57.3755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_128",
    x1: 105.666,
    y1: 4.90899,
    x2: 102.366,
    y2: 58.9321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_128",
    x1: 42.63,
    y1: 51.3826,
    x2: 79.175,
    y2: 48.3546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_52_128",
    x1: 42.63,
    y1: 31.1112,
    x2: 79.175,
    y2: 28.0832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_52_128",
    x1: 42.6301,
    y1: 10.8412,
    x2: 79.1751,
    y2: 7.81021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_52_128",
    x1: 99.0571,
    y1: 26.3218,
    x2: 98.9938,
    y2: 37.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_52_128",
    x1: 108.136,
    y1: 26.5156,
    x2: 108.398,
    y2: 38.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoinLogo);
export default __webpack_public_path__ + "static/media/Neoin Logo.4f3ceb73e50b47c75860baad38d38750.svg";
export { ForwardRef as ReactComponent };